import { useMutation, useQueryClient } from '@tanstack/react-query';

import { routeService } from '../../../../../application/RouteService';
import { useErrorMiddleware } from '../../../../../hooks/useErrorMiddleware';
import { useShowSnackbarMessage } from '../../../../../hooks/useShowSnackbarMessage';
import { RouteActionType } from '../../context/actions';
import { useRouteContext } from '../../context/context';
import { getRouteMutationKey } from '../../hooks';

interface UseRetrieveRouteProps {
  route_id: string;
  log_id: string;
}

export const useAcceptOptimization = () => {
  const queryClient = useQueryClient();
  const { sessionExpiredLogout } = useErrorMiddleware();
  const { showSnackbarMessage } = useShowSnackbarMessage();
  const { routeDispatch } = useRouteContext();

  const { isSuccess, data, error, isLoading, mutate } = useMutation(
    (props: UseRetrieveRouteProps) =>
      routeService.acceptOptimization({ route_id: props.route_id, log_id: props.log_id }),
    {
      onSuccess: async (route) => {
        routeDispatch({
          type: RouteActionType.FETCH_ROUTE_SUCCESS,
          payload: route,
        });
        const routeId = route.id;
        queryClient.setQueryData(getRouteMutationKey({ routeId }), route);
      },
      onError: (err: any, _, context) => {
        console.info(`useAcceptOptimization: `, err?.response);

        if (err?.response?.status === 401) {
          sessionExpiredLogout();
          return;
        }

        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
    }
  );

  return {
    error: error,
    success: isSuccess,
    isLoading: isLoading,
    data: data,
    run: mutate,
  };
};
